import { ModuleApp } from '@huaca/ui';
import { config } from './config';
import { Calculator } from './Calculator';

/** Module roles offered in org admin — mirrors src/products/calculator/roles.ts. */
const MODULE_ROLES = { calculator: ['calculator.manager', 'calculator.viewer'] };

/**
 * The entire app. Every flow in front of the product — login, org onboarding, plan selection,
 * billing return, seats, the error→screen mapping — comes from @huaca/ui, so this module behaves
 * identically to every other one and inherits platform fixes for free.
 */
export function App() {
  return (
    <ModuleApp
      productId={config.productId}
      productName={config.productName}
      moduleRoles={MODULE_ROLES}
      renderProduct={({ showPlans }) => <Calculator onShowPlans={showPlans} />}
    />
  );
}
